import type { PermissionCheckInput } from './PermissionCheckInput.tsx';

const HAM_ADMIN_PERMISSION_ID = 'manage-ham';
const HAM_USER_PERMISSION_ID = 'view-ham';

/**
 * The HAM permission checks. Their resource ARI is the Assets Vertical workspace
 * ARI, which is only known after resolving `assetsVertical_tenantContext`, so
 * these are fetched by a dependent query.
 */
export const getHamPermissionChecks = (
	assetsVerticalWorkspaceAri: string,
): PermissionCheckInput[] => [
	{ resourceId: assetsVerticalWorkspaceAri, permissionId: HAM_ADMIN_PERMISSION_ID },
	{ resourceId: assetsVerticalWorkspaceAri, permissionId: HAM_USER_PERMISSION_ID },
];
